import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import posFlowReducer from "./posSlice";
import settingsReducer from "./settingsSlice";
import clientsReducer from "./clientsSlice";
import salesReducer from "./salesSlice";
import reportsReducer from "./reportsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    pos: posFlowReducer,
    cashDrawer: settingsReducer,
    clients: clientsReducer,
    sales: salesReducer,
    reports: reportsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
